import { useEffect, useState } from 'react';
import './Avaliacoes.css';

const Avaliacoes = ({ appointments = [] }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    // Filtrar os últimos 3 clientes que deixaram avaliação real
    const latestReviews = appointments
        .filter(app => app.status === 'Concluido' && app.rating)
        .sort((a, b) => {
            const dateA = a.reviewedAt || a.date + 'T' + (a.time || '00:00');
            const dateB = b.reviewedAt || b.date + 'T' + (b.time || '00:00');
            return new Date(dateB) - new Date(dateA);
        })
        .slice(0, 3)
        .map(app => ({
            id: app.id,
            name: app.client || 'Cliente Satisfeito',
            service: app.service,
            date: app.date.split('-').reverse().join('/'),
            initial: (app.client || 'C')[0].toUpperCase(),
            comment: app.review || "Cliente avaliou este serviço apenas com estrelas.",
            rating: app.rating || 5
        }));

    useEffect(() => {
        if (latestReviews.length > 1) {
            const timer = setInterval(() => {
                setCurrentIndex((prev) => (prev + 1) % latestReviews.length);
            }, 5000);
            return () => clearInterval(timer);
        }
    }, [latestReviews.length]);

    if (latestReviews.length === 0) return null;

    return (
        <section className="reviews-section fade-in">
            <div className="section-header">
                <span className="section-subtitle">O que dizem nossos clientes</span>
                <h2 className="section-title">Avaliações Recentes</h2>
                <div className="section-divider"></div>
            </div>

            <div className="reviews-container">
                {/* Desktop Grid / Mobile Carousel Wrapper */}
                <div className="reviews-wrapper" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
                    {latestReviews.map((review, index) => (
                        <div key={review.id} className={`review-card ${index === currentIndex ? 'active' : ''}`}>
                            <div className="review-header">
                                <div className="client-info">
                                    <h4 className="client-name">{review.name}</h4>
                                    <span className="review-date">{review.date}</span>
                                </div>
                                <div className="review-rating">
                                    {[...Array(review.rating)].map((_, i) => (
                                        <span key={i} className="star">★</span>
                                    ))}
                                </div>
                            </div>
                            <div className="review-body">
                                <p className="review-comment">"{review.comment}"</p>
                                <span className="review-service">Serviço: {review.service}</span>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Carousel Dots (Mobile Only) */}
                <div className="carousel-dots">
                    {latestReviews.map((_, index) => (
                        <button
                            key={index}
                            className={`dot ${index === currentIndex ? 'active' : ''}`}
                            onClick={() => setCurrentIndex(index)}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Avaliacoes;
